/** Workspace + capability API bindings. */
import { http } from "@/shared/api/http";
import type { CapabilityMatrix } from "@/entities/workspace/capabilities";
import type { Me, Membership, Workspace, WorkspaceProfile } from "@/entities/workspace/model";

export const fetchMe = (): Promise<Me> => http<Me>("/me");

export const listWorkspaces = (): Promise<Workspace[]> =>
  http<Workspace[]>("/workspaces");

export interface CreateWorkspaceInput {
  slug: string;
  profile: WorkspaceProfile;
}

export const createWorkspace = (input: CreateWorkspaceInput): Promise<Workspace> =>
  http<Workspace>("/workspaces", { method: "POST", body: input });

export const fetchWorkspace = (id: string): Promise<Workspace> =>
  http<Workspace>(`/workspaces/${id}`);

export const fetchCapabilityMatrix = (id: string): Promise<CapabilityMatrix> =>
  http<CapabilityMatrix>(`/workspaces/${id}/capabilities`);

export const fetchMembers = (id: string): Promise<Membership[]> =>
  http<Membership[]>(`/workspaces/${id}/members`);

// ── Sprint 1 — Project Symphony ─────────────────────────────────────
export type OperatingMode = "manual" | "autopilot";

export const setOperatingMode = (id: string, mode: OperatingMode): Promise<Workspace> =>
  http<Workspace>(`/workspaces/${id}/operating-mode`, {
    method: "PATCH",
    body: { mode },
  });

// ── Patch 37.4.9 — Founder-editable workspace fields ────────────────
export const updateWorkspaceProfile = (
  id: string,
  profile: WorkspaceProfile,
): Promise<Workspace> =>
  http<Workspace>(`/workspaces/${id}`, {
    method: "PATCH",
    body: { profile },
  });

export const setActiveCampaignCap = (
  id: string,
  cap: number | null,
): Promise<Workspace> =>
  http<Workspace>(`/workspaces/${id}/campaign-cap`, {
    method: "PATCH",
    body: { active_campaign_cap: cap },
  });
